import { createSlice } from "@reduxjs/toolkit";

const defaultColumns = [
  "Lead Name",
  "Activity Notes",
  "Activity Status",
  "Activity Owner",
  "Activity Date",
];

const initialState = {
  selectedColumns: [
    "Lead Name",
    "Activity Notes",
    "Activity Status",
    "Activity Owner",
    "Activity Date",
  ],
};

export const activityColumnSlice = createSlice({
  name: "activityColumn",
  initialState,
  reducers: {
    setColumns: (state, action) => {
      state.selectedColumns = action.payload;
    },
    setDefaultColumns: (state) => {
      state.selectedColumns = defaultColumns;
    },
  },
});

export const { setColumns, setDefaultColumns } = activityColumnSlice.actions;
export default activityColumnSlice.reducer;
